import __var_0__ from './variance.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Uniform distribution variance.
*
* @module @stdlib/stats/base/dists/uniform/variance
*
* @example
* var variance = require( '@stdlib/stats/base/dists/uniform/variance' );
*
* var v = variance( 0.0, 1.0 );
* // returns ~0.083
*
* v = variance( 4.0, 12.0 );
* // returns ~5.333
*
* v = variance( 2.0, 8.0 );
* // returns 3.0
*/

// MODULES //
var variance = __var_0__;


// EXPORTS //
export default variance;
